export default __webpack_public_path__ + "static/media/two_days_back.396a1c91.png";